export class EventValidator {
    validators;
    constructor() {
        this.validators = [];
    }
    addValidator(validator) {
        this.validators.push(validator);
    }
    validate(trackingObject) {
        for (const validator of this.validators) {
            validator.validate(trackingObject);
        }
    }
}
